import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


const About = () => {
  return (
    <div>
      <Container>
        <h3 className='mt-5 mb-5'>Brief History</h3>
        <Row className='d-flex justify-content-center mb-5'>
          <Col md={6}>
            <p className='CPdocs'>Established in the year 2012, the school has been affiliated with the CBSE, New Delhi and is
              managed by the Priyanka Memorial Trust, Yusufpur (Kharba) , a non commercial trust
              dedicated for the cause of education with Indian cultural values and traditions. Priyanka
              Memorial International School, Yusufpur (Kharba), Ghazipur a champion of educational
              institutions of studies through English Medium owes its singular distinction to the founder
              Sh. Krishna Datt Dwivedi, a renowned educationist as well as a philanthropist.
              The school is situated just down the main road connecting Zakhania with Ghazipur city at a
              distance of 12kms from Ghazipur city centre & amidst spectacular natural surrounding of
              corn fields as it apparently mingles in the music of the river Beso , a tributary of the Gangaes
              flowing at a short distance.
              The institution has been evolved for providing younger generation a training ground to grow
              amid the happy and harmonious blend of our ancient culture and modern progressive trends.
              The school is enriched with a superb playground, advanced Physics, Chemistry, Biology,
              Computer Science and Mathematics laboratories , a huge library along with other facilities
              provided to the children in order to maintain the most high status study among the
              intellectual circles.</p>
          </Col>
        </Row>
        <hr />
        <Row className='d-flex justify-content-center mb-5'>
          <h3 className='mt-5 mb-5'>Laboratories</h3>
          <Col md={6}>
            <p className='CPdocs'>The school has well equipped laboratories for Physics, Chemistry Biology, Maths, Computer
              Science and Language etc. The school provides a multi purpose activity house for the students
              to perform various activities time to time.</p>
          </Col>
        </Row>
        <hr />
        <Row className='d-flex justify-content-center mb-5'>
          <h3 className='mt-5 mb-5'>Computer Education</h3>
          <Col md={6}>
            <p className='CPdocs'>Computer education is compulsory for students from Grade I to Grade VIII. However, it is
              optional for higher classes. The school provides a Wi-Fi connected well equipped computer lab
              with 25 computers for the student to full fill their practical skill.</p>
          </Col>
        </Row>
        <hr />
        <Row className='d-flex justify-content-center mb-5'>
          <h3 className='mt-5 mb-5'>Career Guidance & Personality Developments</h3>
          <Col md={6}>
            <p className='CPdocs'>It is considered that the school is a training workshop for preparing learners to lay down the
              founding stone of education, manners, intelligence, creativity and personality enriched with
              harmonious etiquette in the society. They are prepared to face challenges in competitive ways
              of education and views to create their own recognition. However, they are inspired with the
              field of their interest to build carriers keeping pace with today’s global challenges.</p>
          </Col>
        </Row>
        <hr />
        <Row className='d-flex justify-content-center mb-5'>
          <h3 className='mt-5 mb-5'>Co-Curricular Activities</h3>
          <Col md={6}>
            <p className='CPdocs'>Inter-school and inter-house competitions of sports, debate, quiz, art & craft, elocution,
              antakshari, yoga, news reading, fancy dress competetion, poets’ meet, best out of waste,
              rangoli, rakhi designing, poster making, essay writing and calligraphy etc, are regularly
              conducted by the school as per the annual calender keeping pace with the CBSE
              curriculum (as co-scholastic activities).
              Children are involved in a wide spectrum of interesting activities namely science exhibition,
              public speaking, project works, drama, quiz, dance, singing, games & sport etc. Men of
              merit and national repute are invited to the school for interacting with the students and
              inspiring them with their qualities.</p>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default About